import { SHOPIFY_CHECK_REQUEST, SHOPIFY_CHECK_SUCCESS, SHOPIFY_CHECK_FAILURE, SHOPIFY_SAVE_REQUEST, SHOPIFY_SAVE_SUCCESS, SHOPIFY_SAVE_FAILURE } from '../actions/shopifyActions';

const initialState = {
  loading: false,
  error: null,
  isConnected: false,
  stores: [],
  lastCheckedAt: null,
  raw: null, // Add raw data storage
};

export default function shopifyReducer(state = initialState, action) {
  switch (action.type) {
    case SHOPIFY_CHECK_REQUEST:
    case SHOPIFY_SAVE_REQUEST:
      return { ...state, loading: true, error: null };
    case SHOPIFY_CHECK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        isConnected: !!action.payload?.isConnected,
        stores: Array.isArray(action.payload?.stores) ? action.payload.stores : [],
        lastCheckedAt: Date.now(),
        raw: action.payload?.raw || null, // Store the raw API response
      };
    case SHOPIFY_SAVE_SUCCESS:
      return { ...state, loading: false, error: null };
    case SHOPIFY_CHECK_FAILURE:
    case SHOPIFY_SAVE_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}


